import { ButtonContentAlignmentEnum } from './Button.types';

export const AlignContentMap: Record<ButtonContentAlignmentEnum, string> = {
  'Center': 'center',
  'SpaceBetween': 'spaceBetween'
};